import { render } from "./Impresszum.vue?vue&type=template&id=a988923a"
const script = {}
script.render = render

export default script